import type { GoogleReview } from '../types';

export const googleTestimonials: GoogleReview[] = [
  {
    reviewer: 'Amal Hassan-Ali',
    rating: 5,
    comment:
      'Used the booth for a youth graduation — the team was patient, professional and a highlight of the night. Corporate guests loved how smooth it all ran.',
    segment: 'Corporate',
    createTime: '2024-06-01T00:00:00.000Z',
    relativeTimeDescription: '6 months ago'
  },
  {
    reviewer: 'Emma Lipson',
    rating: 5,
    comment:
      '360 Booth Time delivered for our 800-person gala. Khalid was professional and the keepsake clips made sponsors very happy.',
    segment: 'Corporate',
    createTime: '2024-05-20T00:00:00.000Z',
    relativeTimeDescription: '7 months ago'
  },
  {
    reviewer: 'Sim Ros',
    rating: 5,
    comment:
      'We booked the team for our wedding and the service plus guest experience were impeccable. Premium presentation from bump-in to final video.',
    segment: 'Wedding',
    createTime: '2024-04-15T00:00:00.000Z',
    relativeTimeDescription: '8 months ago'
  },
  {
    reviewer: 'Jessica Gala',
    rating: 5,
    comment:
      'After seeing them at Leonda By The Yarra I booked them for my son’s birthday — flawless quality and so much fun for every age group.',
    segment: 'Wedding',
    createTime: '2024-03-10T00:00:00.000Z',
    relativeTimeDescription: '9 months ago'
  },
  {
    reviewer: 'Sajed Awwad',
    rating: 5,
    comment:
      'Khalid and the crew brought the energy to our brand launch. Instant delivery plus the branded gallery made post-event marketing effortless.',
    segment: 'Corporate',
    createTime: '2024-02-05T00:00:00.000Z',
    relativeTimeDescription: '10 months ago'
  },
  {
    reviewer: 'Daman Dosanjh',
    rating: 5,
    comment:
      'Booked for an 18th & 21st — elegant setup, suited staff and the cinematic lighting everyone expects at a premium party.',
    segment: 'Wedding',
    createTime: '2024-01-22T00:00:00.000Z',
    relativeTimeDescription: '11 months ago'
  },
  {
    reviewer: 'Jara Homes',
    rating: 5,
    comment:
      'Hired both the photo booth and 360 platform for our corporate showcase. Attendants were perfectly on brand and every clip looked editorial.',
    segment: 'Corporate',
    createTime: '2023-12-18T00:00:00.000Z',
    relativeTimeDescription: '1 year ago'
  },
  {
    reviewer: 'Sim Ros',
    rating: 5,
    comment:
      'We engaged the team for our premium wedding clients. They’re discreet, polished and deliver the calibre of content our planners demand.',
    segment: 'Wedding',
    createTime: '2023-11-09T00:00:00.000Z',
    relativeTimeDescription: '1 year ago'
  },
  {
    reviewer: 'Benny Nguyen',
    rating: 5,
    comment:
      'From enquiry to pack down the process was concierge-level. Sponsors loved the branded gallery and instant metrics they provided.',
    segment: 'Corporate',
    createTime: '2023-10-01T00:00:00.000Z',
    relativeTimeDescription: '1 year ago'
  }
];
